import moment from 'moment-timezone';

export const getDaysOfWorkingWeek = (sunday: string) => {
    return [...Array(7)]
        .map((x, i) => ({
            label: moment(sunday).add(i, 'day').format('ddd MMM DD'),
            value: moment(sunday).add(i, 'day')
        }));
};